export default __webpack_public_path__ + "static/media/deposits-active.89b2e20d.svg";